.hitSlop {
  position: relative;
  display: inline-block;
  cursor: var(--hitslop-cursor);
}

.hitSlop::before {
  content: '';
  position: absolute;
  inset: calc(var(--hitslop-top) * -1px) calc(var(--hitslop-right) * -1px)
    calc(var(--hitslop-bottom) * -1px) calc(var(--hitslop-left) * -1px);
  cursor: var(--hitslop-cursor);
  z-index: var(--hitslop-zindex);
}
